import createCurrencyString from '@repo/ui/src/functions/currency-functions';
import useCurrentUrl from '@repo/ui/src/hooks/useCurrentUrl';
import React from 'react';

export const useCurrencyString = (defaultCurrency?: string) => {
  const { locale, currency: currentUrlCurrency } = useCurrentUrl();
  return React.useCallback(
    (value: number | null | undefined, currency = defaultCurrency ?? currentUrlCurrency) =>
      value == null ? null : createCurrencyString(locale, currency, value),
    [locale, defaultCurrency, currentUrlCurrency],
  );
};
